import { render, staticRenderFns } from "./ResourceAIImportInterface.vue?vue&type=template&id=2309f823"
import script from "./ResourceAIImportInterface.vue?vue&type=script&lang=js"
export * from "./ResourceAIImportInterface.vue?vue&type=script&lang=js"
import style0 from "./ResourceAIImportInterface.vue?vue&type=style&index=0&id=2309f823&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtnToggle,VSelect,VTextField})
